"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_input_mask_1 = __importDefault(require("react-input-mask"));
const react_number_format_1 = __importDefault(require("react-number-format"));
const moment_1 = __importDefault(require("moment"));
const __1 = require("../..");
const TextArea_1 = require("./TextArea");
const Button_1 = require("../Button");
var InputMask;
(function (InputMask) {
    InputMask["cpf"] = "999.999.999-99";
    InputMask["cep"] = "99999-999";
})(InputMask = exports.InputMask || (exports.InputMask = {}));
const Input = (props) => {
    const className = classnames_1.default({
        "form-control": !props.readonly,
        "form-control-plaintext": props.readonly,
    });
    function mountDate(value) {
        return (react_1.default.createElement(react_number_format_1.default, { id: props.name, name: props.name, className: className, readOnly: props.readonly, format: "##/##/####", mask: "_", disabled: props.disabled, value: value, onChange: (e) => props.onChange(e.target.value), onBlur: props.onBlur, placeholder: props.placeholder }));
    }
    function mountPercent(value) {
        return (react_1.default.createElement(react_number_format_1.default, { id: props.name, name: props.name, className: className, readOnly: props.readonly, decimalSeparator: ",", decimalScale: 2, prefix: "%", fixedDecimalScale: true, disabled: props.disabled, value: value, onChange: (e) => props.onChange(e.target.value), onBlur: props.onBlur, placeholder: props.placeholder }));
    }
    function mountTextarea(value) {
        return react_1.default.createElement(TextArea_1.TextArea, Object.assign({}, props, { value: value }));
    }
    function mountMoney(value) {
        return (react_1.default.createElement(react_number_format_1.default, { id: props.name, name: props.name, className: className, readOnly: props.readonly, decimalScale: 2, fixedDecimalScale: true, thousandSeparator: ".", decimalSeparator: ",", disabled: props.disabled, value: value, onChange: (e) => props.onChange(e.target.value), onBlur: props.onBlur, placeholder: props.placeholder }));
    }
    function mountField(value) {
        switch (props.type) {
            case 'date':
                return mountDate(value);
            case 'percent':
                return mountPercent(value);
            case 'textarea':
                return mountTextarea(value);
            case 'money':
                return mountMoney(value);
            default:
                return (react_1.default.createElement(react_input_mask_1.default, { id: props.name, name: props.name, mask: InputMask[props.mask], value: value, type: props.type, max: props.max, maxLength: props.max, className: className, readOnly: props.readonly, placeholder: props.placeholder, disabled: props.disabled, onChange: (e) => props.onChange(e.target.value), onBlur: props.onBlur }));
        }
    }
    function renderField() {
        const campoClasses = classnames_1.default({
            "input-group": props.group,
        });
        let value = "";
        if (props.value)
            value = props.value.toString();
        if (typeof value === typeof Date)
            value = moment_1.default(value).format("dd/MM/yyyy");
        return (react_1.default.createElement("div", { className: campoClasses },
            props.group && props.buttonLeft && (react_1.default.createElement("div", { className: "input-group-prepend" }, renderGroupButton())),
            mountField(value),
            props.group && !props.buttonLeft && (react_1.default.createElement("div", { className: "input-group-append" }, renderGroupButton()))));
    }
    function onButtonClick() {
        if (props.onButtonClick)
            props.onButtonClick();
    }
    function renderGroupButton() {
        return (react_1.default.createElement(Button_1.Button, { title: props.buttonTitle, type: props.buttonType, onClick: onButtonClick, icon: props.icon, iconRight: props.iconRight }));
    }
    const containerClassName = classnames_1.default("form-group", {
        "col-md": props.inline,
    });
    if (props.labelPosition === "up") {
        return (react_1.default.createElement("div", { className: containerClassName },
            props.title && (react_1.default.createElement(__1.Label, { value: props.title, size: props.labelSize, labelPosition: props.labelPosition, className: props.labelClassName, required: props.required })),
            renderField()));
    }
    else {
        const fieldClassName = classnames_1.default({
            'col': !props.fieldSize,
            [`col-md-${props.fieldSize}`]: props.fieldSize,
        });
        return (react_1.default.createElement("div", { className: containerClassName },
            react_1.default.createElement(__1.Row, null,
                props.title && (react_1.default.createElement(__1.Label, { value: props.title, size: props.labelSize, labelPosition: props.labelPosition, className: props.labelClassName, required: props.required })),
                react_1.default.createElement("div", { className: fieldClassName }, renderField()))));
    }
};
exports.Input = Input;
Input.defaultProps = {
    type: 'text',
};
